import type { BaseModalProps } from '@byecode/ui'
import { DesktopModal } from '@byecode/ui'
import React from 'react'

import NetEaseFreeAccount from './NetEaseFreeAccount'

interface NetEaseFreeAccountModalProps extends BaseModalProps {}

export const NetEaseFreeAccountModal: React.FunctionComponent<NetEaseFreeAccountModalProps> = ({ ...rest }) => {
    return (
        <DesktopModal
            width={676}
            {...rest}
            styles={{
                modal: {
                    maxHeight: 'calc(100% - 48px)'
                },
                body: {
                    padding: '0!important'
                },
                header: {
                    borderStyle: 'none'
                }
            }}
        >
            <NetEaseFreeAccount onClose={rest.onClose} />
        </DesktopModal>
    )
}
